import React from "react";
import {
    Button,
    Card,
    CardContent,
    Collapse,
    Grid,
    MenuItem,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { DOCUMENT_STATUS_OPTIONS } from "./constants";

const DocumentFilters = ({
    open = false,
    filters = {},
    onFiltersChange = () => {},
    onClearFilters = () => {},
}) => {
    const handleFilterFieldChange = (fieldName, fieldValue) => {
        onFiltersChange({
            ...filters,
            [fieldName]: fieldValue,
        });
    };

    return (
        <Collapse in={open}>
            <Card sx={{ mb: 2 }}>
                <CardContent>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                        <Typography variant="h4">Filtros</Typography>
                        <Button size="small" onClick={onClearFilters}>Limpiar filtros</Button>
                    </Stack>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Estado del documento"
                                value={filters.documents_status || ""}
                                onChange={(event) => handleFilterFieldChange("documents_status", event.target.value)}
                            >
                                {DOCUMENT_STATUS_OPTIONS.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Desde"
                                InputLabelProps={{ shrink: true }}
                                value={filters.date_from || ""}
                                onChange={(event) => handleFilterFieldChange("date_from", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Hasta"
                                InputLabelProps={{ shrink: true }}
                                value={filters.date_to || ""}
                                onChange={(event) => handleFilterFieldChange("date_to", event.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Viaje (id)"
                                placeholder="Ej: 4412"
                                value={filters.trip_id || ""}
                                onChange={(event) => handleFilterFieldChange("trip_id", event.target.value)}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Collapse>
    );
};

export default DocumentFilters;
